module.exports = __webpack_public_path__ + "img/Notisphere_Logo_Color_Light_PAR.8f866a35.png";